// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdownSelector_box {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}

.dropdownSelector_box label {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  white-space: nowrap;
}

.dropdownSelector_box select {
  padding: 6px 10px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  font-size: 13px;
  color: var(--text-primary);
  background-color: var(--bg-card);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Filters/DropdownSelector/DropdownSelector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;AACjB","sourcesContent":[".dropdownSelector_box {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: center;\n}\n\n.dropdownSelector_box label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.dropdownSelector_box select {\n  padding: 6px 10px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  font-size: 13px;\n  color: var(--text-primary);\n  background-color: var(--bg-card);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
